require('jquery-validation');
// require('./init-validation');

var $ = require('jquery');
var ValidationHelpers = require('./form-validation-helper');

var FORMS      = '.js-formValidateSubmitNative';

module.exports = function() { /* Nothing to Export */ };



$(document).ready(function() {

    $(FORMS).each(function(){

        /*
         * Initialize the jQuery Validator
         */
        $(this).validate({

            // Localize
            lang: $('html').attr('lang') || 'en',

            // On Validation, submit the form
            submitHandler: function(form) {
                ValidationHelpers.setLoading( $(form), true);
                ValidationHelpers.doNativeSubmit(form);
            }
        });

        /*
         * This helper method prepares messages for the validator.
         * It MUST be loaded after the validator is loaded.
         */
        ValidationHelpers.loadFormMessages( $(this) );

    });

});
